import { NotebookMessageDtoSchema } from "@notebook/data/dto/notebook-message.dto";
import * as z from "zod";

const NotebookStationDtoSchema = z.object({
    id: z.number().positive(),
    name: z.string().trim(),
});
const NotebookCropTypeDtoSchema = z.object({
    id: z.number().positive(),
    code: z.string().trim(),
});

const NotebookCampaignDtoSchema = z.object({
    id: z.number().positive(),
    name: z.string().trim(),
    creator: z.object({
        id: z.number().positive(),
        email: z.string().trim(),
    }),
    start_date: z.string().trim(),
    end_date: z.string().trim(),
});

export const NotebookDtoSchema = z
    .object({
        id: z.number().positive(),
        campaign: NotebookCampaignDtoSchema,
        crop_type: NotebookCropTypeDtoSchema,
        stations: z.array(NotebookStationDtoSchema),
        notebook_messages: z.array(NotebookMessageDtoSchema),
    })
    .readonly();

export type NotebookDto = z.output<typeof NotebookDtoSchema>;
